import { Component } from '@angular/core';

@Component({
    selector: 'nwm-awards',
    templateUrl: `./awards.component.html`,
    styleUrls: ['./awards.component.scss']
})

export class AwardsComponent {
}